"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";
import Ptest from "../../assets/images/Ptest2.png";
import Threat from "../../assets/images/Threat.png";
import Security from "../../assets/images/SA2.png";

export function Services() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid auto-cols-fr grid-cols-1 items-start justify-start gap-y-12 md:grid-cols-[0.5fr_1fr] md:gap-x-12 md:gap-y-16 lg:gap-x-20">
          <div>
            <p className="mb-3 font-semibold md:mb-4">Services</p>
            <h2 className="rmb-5 text-4xl leading-[1.2] md:mb-6 md:text-[40px] lg:text-[40px] max-w-[500px]">
            Endecken Sie unsere Sicherheits-Lösungen            </h2>
            <p className="mb-6 md:mb-8 md:text-md">
            In der heutigen digitalen Landschaft sind Unternehmen zunehmend Cyberbedrohungen ausgesetzt. Unsere Cybersicherheitslösungen bieten Schutz vor diesen Gefahren und sichern Ihre digitalen Assets
            </p>
           
          </div>
          <div className="grid w-full auto-cols-fr grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 md:gap-y-16 lg:gap-x-12">
            <div>
              <div className="rb-5 mb-5 md:mb-6">
                <img
                  src={Ptest}
                  className="size-12"
                  alt=" logo"
                />
              </div>
              <h1 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl max-w-[300px]">
              Sicherheitsbewertung & Risikoanalyse
              </h1>
              <p>Identifizieren Sie Schwachstellen in Ihren Systemen und erhalten Sie detaillierte Berichte mit Handlungsempfehlungen.</p>
            </div>
            <div>
              <div className="rb-5 mb-5 md:mb-6">
                <img
                  src={Threat}
                  className="size-12"
                  alt="Relume logo"
                />
              </div>
              <h1 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl max-w-[300px]">
              Kontinuierliches Sicherheitsmonitoring
              </h1>
              <p>Überwachen Sie Ihre Netzwerke rund um die Uhr, um Bedrohungen frühzeitig zu erkennen und zu neutralisieren.</p>
            </div>
            <div>
              <div className="rb-5 mb-5 md:mb-6">
                <img
                  src={Security}
                  className="size-12"
                  alt="Relume logo"
                />
              </div>
              <h1 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl max-w-[300px]">
              Schulung & Sensibilisierung
              </h1>
              <p>Schulen Sie Ihre Mitarbeiter im sicheren Umgang mit digitalen Ressourcen und erhöhen Sie das Sicherheitsbewusstsein.</p>
            </div>
            <div>
              <div className="rb-5 mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  className="size-12"
                  alt="Relume logo"
                />
              </div>
              <h1 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl max-w-[300px]">
              Maßgeschneidert auf Ihre Bedürfnisse
              </h1>
              <p>
              Wir passen unsere Dienstleistungen individuell an die Bedürfnisse Ihres Unternehmens an.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
